import { Injectable } from '@angular/core';

/*
  Generated class for the SizesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SizesProvider {
  sizes: any = null;

  constructor() {
    // console.log('Hello SizesProvider Provider');
  }


  getSizes(){
    if(this.sizes == null){
      this.sizes = [];
      this.initSizes();
    }

    // console.log("getSizes",this.sizes);
    return this.sizes;
  }
  getSize(index){
    // console.log("getSize", index);
    if(this.sizes == null){
      this.sizes = [];
      this.initSizes();
    }
    // console.log("this.sizes",this.sizes);
    return this.sizes[index];
  }

  initSizes(){
    this.sizes=[];
    this.sizes.push({
      title:"Carré",
      class:"size_carre",
      width:1024,
      height:1024
    });
    this.sizes.push({
      title:"Portrait",
      class:"size_portrait",
      width:900,
      height:1200
    });
    this.sizes.push({
      title:"Landscape",
      class:"size_landscape",
      width:1200,
      height:900
    });
    this.sizes.push({
      title:'5.5" iPhone 8 Plus portrait',
      class:"size_iphone_portrait",
      width:1242,
      height:2208
    });
    this.sizes.push({
      title:'5.5" iPhone 8 Plus landscape',
      class:"size_iphone_landscape",
      width:2208,
      height:1242
    });
    this.sizes.push({
      title:'5.8" iPhone X portrait',
      class:"size_iphonex_portrait",
      width:1125,
      height:2436
    });
    this.sizes.push({
      title:'5.8" iPhone X landscape',
      class:"size_iphonex_landscape",
      width:2436,
      height:1125
    });
    this.sizes.push({
      title:'6.5" iPhone Xs Max portrait',
      class:"size_iphonexs_max_portrait",
      width:1242,
      height:2688
    });
    this.sizes.push({
      title:'6.5" iPhone Xs Max landscape',
      class:"size_iphonexs_max_landscape",
      width:2688,
      height:1242
    });
    this.sizes.push({
      title:'12.9" iPad portrait',
      class:"size_ipad_portrait",
      width:2048,
      height:2732
    });
    this.sizes.push({
      title:'12.9" iPad landscape',
      class:"size_ipad_landscape",
      width:2732,
      height:2048
    });
    this.sizes.push({
      title:'Android Landscape Picture',
      class:"size_android_landscape_picture",
      width:1024,
      height:500
    });
    this.sizes.push({
      title:'Android TV Banner',
      class:"size_android_tv_banner",
      width:1280,
      height:720
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/sizes/sizes.ts